import { render, staticRenderFns } from "./add-campus-drive-modal.vue?vue&type=template&id=e2b124e2&scoped=true"
import script from "./add-campus-drive-modal.vue?vue&type=script&lang=js"
export * from "./add-campus-drive-modal.vue?vue&type=script&lang=js"
import style0 from "./add-campus-drive-modal.vue?vue&type=style&index=0&id=e2b124e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b124e2",
  null
  
)

export default component.exports